import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  AppBar,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Snackbar, Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';
import PaidIcon from '@mui/icons-material/Paid';
import PublicIcon from '@mui/icons-material/Public';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // CheckCircle icon for better visual representation
import EventIcon from '@mui/icons-material/EventAvailable';
import ActivitiesIcon from '@mui/icons-material/Star';
import ukdegree from '../img/ukdegree.jpg';
import Webhead from '../Webhead';
import { useState } from 'react';
import Webfoot from '../Webfoot';


const Suk = () => {

  const [value, setValue] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const benefits = [
    {
      title: "Affordable Education",
      // description: "UK offers a lower cost of living and tuition fees compared to other popular study destinations.",
      icon: <PaidIcon />
    },
   
    {
      title: "Innovative and Abundant Research Opportunities",
      // description: "UK provides pathways for international students to apply for permanent residency.",
      icon: <PublicIcon />
    },
    {
      title: "Healthy and Safe Communities",
      // description: "Experience vibrant student life, cultural diversity, and a wide range of extracurricular activities.",
      icon: <EmojiPeopleIcon />
    },
    {
      title: "Scholarships and Financial Support",
      // description: "UK is known for its safety and welcoming atmosphere, providing peace of mind to students.",
      icon: <LiveHelpIcon />
    },
    {
      title: "Possible to work while you study",
      // description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
    {
      title: "Multicultural Nation",
      // description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
    {
      title: "The best possible place to study and learn English",
      // description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
    {
      title: "Choose from over 50,000 courses in more than 25 subject areas",
      // description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
    {
      title: "Shorter courses which indicate reduction in tuition fees and accommodation costs",
      // description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
   
    {
      title: "Internationally Recognized Courses & Qualifications",
      // description: "Students can engage in groundbreaking research and collaborate with leading experts.",
      icon: <SchoolIcon />
    }
  ];

  return (
    <div>
      <Webhead />
      <div>
        {/* <StudyInUK /> */}
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>

          <Box
            sx={{
              backgroundImage: `url(${ukdegree})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: 'white',
              padding: '100px 20px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" gutterBottom>
              Pursue Your Higher Education In An UK University
            </Typography>
            <Typography variant="h6" paragraph>
              Complete Admissions Support to Study in UK
            </Typography>
            <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
              Get Started
            </Button>
          </Box>

          {/* Tabs for Different Sections */}
          <AppBar position="static" color="default">
            <Tabs value={value} onChange={handleTabChange} aria-label="tabs">
              <Tab label="Why Study in UK?" />
              {/* <Tab label="Admission Process" /> */}
              {/* <Tab label="Student Life" /> */}
            </Tabs>
          </AppBar>

          {/* Tab Content */}
          {value === 0 && (
            <Box sx={{ padding: '5px 0' }}>
              <br />
              <Box sx={{ padding: '20px', backgroundColor: '#F9BB16', borderRadius: '8px', textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'black' }}>
                  Study In UK
                </Typography>
              </Box>
              <br />
              <Typography variant="body1" paragraph>
                The UK has traditionally been one of the world’s leading educational destinations. It boasts of centuries-old universities that have a legacy of producing the finest minds in the world. Today, it remains one of the best destinations for students seeking high-quality education and a welcoming educational environment. Allians International helps students at every step of their UK admissions process. We have the experience and comprehensive service package to make your student journey stress free and help you begin your education at the right time, in the best possible university.
                The UK is second to the US as the favored destination for international students. It has some of the best ranked universities in the world, some of which appear in the world university rankings.
                The degrees offered by the UK higher education institutes are recognized worldwide. Students from UK universities get an opportunity to develop their skills and knowledge at competent levels.
                There are options to continue with post-graduate studies in most UK universities with some of them even promising to sponsor Tier 4 visas.
              </Typography>

              <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black' }}>
                  Why Study In UK?
                </Typography>
                <br />
              <Grid container spacing={2} justifyContent="center">
                {benefits.map((benefit, index) => (
                  <Grid item xs={8} sm={8} md={6} key={index}>
                    <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', padding: '16px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                      <IconButton color="primary" sx={{ marginRight: '16px' }}>
                        {benefit.icon}
                      </IconButton>
                      <CardContent sx={{ flex: 1 }}>
                        <Typography variant="h6" gutterBottom>
                          {benefit.title}
                        </Typography>
                        {/* Uncomment below line if you want to include the description */}
                        {/* <Typography variant="body2">{benefit.description}</Typography> */}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          {value === 1 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Admission Process
              </Typography>
              <Typography variant="body1" paragraph>
                The admission process for studying in UK typically includes the following steps:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Choose a program and institution.",
                  "Check the admission requirements.",
                  "Prepare required documents (transcripts, letters of recommendation, etc.).",
                  "Submit your application online.",
                  "Receive an acceptance letter and pay tuition fees.",
                  "Apply for a study permit.",
                ].map((step, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <SchoolIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{step}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

          {value === 2 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa', marginTop: 4 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Student Life
              </Typography>
              <Typography variant="body1" paragraph>
                Student life in UK is diverse and vibrant. You can expect to engage in:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Participating in clubs and organizations.",
                  "Attending social events and networking opportunities.",
                  "Enjoying the cultural and recreational activities in your area.",
                ].map((activity, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <EventIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{activity}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

          {/* FAQ Accordion */}
          {/* <Box sx={{ marginTop: 4 }}>
                        <Typography variant="h5" gutterBottom>Frequently Asked Questions</Typography>
                        <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                                    Cost Of Studying In The USA
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                                <Box sx={{ padding: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        The US Universities fall under two major categories: public funded and private institutions. International students’ tuition expenses at state schools are based on non-resident costs,
                                        which are still usually less expensive than those of private universities.
                                        You will need approximately $10,000 to $55,000 annually to cover your tuition fees.
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                                    Work Authorization for Students
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                                <Box sx={{ padding: 2 }}>
                                    <strong>STUDENT APPLICANT:</strong>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">Students must be over 18 years of age</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">International students can work on-campus up to 20 hours/week or less during the academic terms and full-time during the academic break periods including summer time</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1"> Off-campus employment requires some form of written or documented authorization
                                            issued by either the USCIS or OISS. And also, you must be currently in legal status and have been enrolled as an F-1 student in the US for a minimum of one academic year to be eligible for any form of off-campus employment</Typography>
                                    </Box>
                                    <strong>SPOUSE:</strong>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">Per U.S. government regulations, only married spouses can obtain a dependent visa status. The student, scholar or employee can add a dependent spouse to his or her record, and the spouse can then obtain a dependent visa status (F-2, J-2 or H-4).
                                            These dependent statuses do have certain restrictions.</Typography>
                                    </Box>

                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                                    After You Graduate
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                                <Box sx={{ padding: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">F1 visa holders are eligible for up to 12 months of OPT (optional practical training) on completion of graduation. That means you can work for a year after you finish your studies
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">It is a temporary employment permission allowing students the opportunity to gain practical experience in their field of study</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">After that, you’ll be required to apply for a work visa if you have to continue working in the US. You can remain in the US up to 60 days after the completion of your course even if you don’t have a job offer or haven’t applied for OPT</Typography>
                                    </Box>

                                </Box>
                            </AccordionDetails>
                        </Accordion>

                    </Box> */}

          {/* Snackbar for user feedback */}
          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message="Get Started button clicked!"
            autoHideDuration={4000}
          />
        </Container>
      </div>
      <Webfoot />
    </div>
  );
};

export default Suk;